import { Store } from '../../../types';
import { getLangVar } from '../../../util/misc';
import { EmailIcon, LocationIcon, PhoneIcon, SiteIcon, WorkHoursIcon } from './icons';

export default function StoreCard({ store }: { store: Store }) {
    const address = getLangVar(store, 'address') || '';
    const phone = getLangVar(store, 'phone') || '';
    const email = getLangVar(store, 'email') || '';
    const workHours = getLangVar(store, 'workHours') || '';
    return (
        <div className="map-info-item">
            <span className="map-info-item__title">{getLangVar(store, 'name')}</span>
            <ul className="map-info-item__list">
                {address && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <LocationIcon />
                        </div>
                        <span className="map-info-item__txt">{address}</span>
                    </li>
                )}
                {store.address && !address && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <LocationIcon />
                        </div>
                        <span className="map-info-item__txt">{store.address}</span>
                    </li>
                )}
                {workHours && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <WorkHoursIcon />
                        </div>
                        <span className="map-info-item__txt">{workHours}</span>
                    </li>
                )}
                {phone && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <PhoneIcon />
                        </div>
                        <span className="map-info-item__txt">
                            <a href={`tel:${phone}`}>{phone}</a>
                        </span>
                    </li>
                )}
                {store.url && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <SiteIcon />
                        </div>
                        <a
                            href={store.url}
                            target="_blank"
                            className="map-info-item__txt link"
                            rel="noreferrer"
                        >
                            {store.url}
                        </a>
                    </li>
                )}
                {email && (
                    <li className="map-info-item__list-item">
                        <div className="map-info-item__icon-cont">
                            <EmailIcon />
                        </div>
                        <a
                            href={`mailto:${email}`}
                            target="_blank"
                            className="map-info-item__txt link"
                            rel="noreferrer"
                        >
                            {email}
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
}
